import { useEffect, useRef } from 'react'

// Run a callback when the connection watchdog un-wedges the Supabase client
// (it dispatches `chatrone:connection-recovered` after a stuck token-refresh
// is aborted and the client recovers). Search boxes and pickers use this to
// re-run their current query so results populate without the user re-typing —
// the "always functional without a refresh" guarantee.
//
// The callback is tracked in a ref so the listener always sees the latest
// closure without re-subscribing on every render.
export function useConnectionRecovered(fn) {
  const fnRef = useRef(fn)
  fnRef.current = fn
  useEffect(() => {
    const handler = () => { try { fnRef.current?.() } catch { /* never throw from a recovery handler */ } }
    window.addEventListener('chatrone:connection-recovered', handler)
    return () => window.removeEventListener('chatrone:connection-recovered', handler)
  }, [])
}
